export const selectIsLoading = state => state.loadingAnimation.isLoading;
